import React from 'react';
import { SinglePaymentContainer } from './Container';
import { useParams } from 'react-router';
export var RoutedSinglePayment = function () {
    var paymentId = useParams().paymentId;
    return React.createElement(SinglePaymentContainer, { invoicePaymentId: paymentId });
};
